module.exports = __webpack_public_path__ + "static/water_optimos4-6ebe5c1cabfcc77c6c13ff817d90aba5.jpg";